import React from 'react';
import {t} from '@lingui/core/macro';

import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import {isTranslate} from 'shared/lib/lang';
import {CollapsiblePanel} from 'entities/tariff';
import ModalBlockButton from 'shared/ui/Button/ModalBlockButton/ModalBlockButton';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import useHttpMonitorForm from 'features/http/model/useHttpMonitorForm';
import {HTTPS_DEPENDENT_CHECK_KEYS, CheckInterval, GeoCheck} from 'entities/monitor';

import InputNameBlock from './InputNameBlock/InputNameBlock';
import RequestMethod from './RequestMethod/RequestMethod';
import RequestHeadersField from './RequestHeadersField/RequestHeadersField';
import RequestTimeout from './RequestTimeout/RequestTimeout';
import CheckboxBlock from './CheckboxBlock/CheckboxBlock';
import DomainChecksBlock from './CheckboxBlock/DomainChecksBlock/DomainChecksBlock';
import NotifySettingsSubform from './NotifySettingsSubform/NotifySettingsSubform';

import styles from './HttpMonitorForm.module.scss';

interface IHttpMonitorFormProps {
    onSuccess: () => void,
    item?: IHttpMonitorOutput,
    onClose?: () => void,
}

const HttpMonitorForm: React.FC<IHttpMonitorFormProps> = ({onSuccess, item, onClose}) => {
    const {form, isNew, isSubmitting, freeTariff, isHttpUrl, submit} = useHttpMonitorForm({item, onSuccess});
    const {register, formState, control, setValue, getValues, watch} = form;
    const {errors, isValid} = formState;

    const HTTP_URL_HINT = t`Недоступно для адреса по http://. Укажите https://, чтобы включить проверку.`;

    return (
        <form onSubmit={submit} className={styles.form}>
            <ModalBodyWrapper>
                <InputNameBlock item={item} register={register} control={control} errors={errors}/>
                <CheckInterval item={item} setValue={setValue} errors={errors} watch={watch}/>
                <RequestMethod item={item} register={register} isFreeTariff={freeTariff} watch={watch}/>
                {!isTranslate() && <RequestHeadersField control={control} register={register}/>}
                <RequestTimeout item={item} setValue={setValue}/>
                <GeoCheck item={item} control={control} setValue={setValue}/>
            </ModalBodyWrapper>
            <ModalBodyWrapper>
                <CollapsiblePanel
                    title={t`Дополнительно`}
                    defaultExpanded
                    isFreeTariff={freeTariff}
                >
                    <CheckboxBlock
                        item={item}
                        getValues={getValues}
                        control={control}
                        register={register}
                        setValue={setValue}
                    />
                </CollapsiblePanel>
            </ModalBodyWrapper>
            {isNew && (
                <ModalBodyWrapper>
                    <CollapsiblePanel
                        title={t`Мониторинг домена`}
                        defaultExpanded
                        isFreeTariff={freeTariff}
                        premiumCondition="monitor_ssl_enabled"
                    >
                        <DomainChecksBlock
                            register={register}
                            disabledKeys={isHttpUrl ? HTTPS_DEPENDENT_CHECK_KEYS : undefined}
                            disabledHint={HTTP_URL_HINT}
                        />
                    </CollapsiblePanel>
                </ModalBodyWrapper>
            )}
            <ModalBodyWrapper>
                <CollapsiblePanel
                    title={t`Уведомления`}
                    defaultExpanded={false}
                >
                    <NotifySettingsSubform
                        item={item}
                        control={control}
                        register={register}
                    />
                </CollapsiblePanel>
            </ModalBodyWrapper>
            <ModalBlockButton
                primaryButtonText={isNew ? t`Добавить` : t`Сохранить`}
                primaryButtonType="submit"
                primaryButtonLoading={isSubmitting}
                primaryButtonDisabled={!isValid}
                secondaryButtonOnClick={onClose}
            />
        </form>
    );
};

export default HttpMonitorForm;
